import { useEffect } from "react"
import { useSelector } from "react-redux"
import { Box, CircularProgress, Paper, Typography } from "@mui/material"
import HawaiiGet from "./common/HawaiiGet"
import analytics from "src/app/analytics"
import { useLazyGetCartQuery } from "src/features/checkout/storefrontCartApi"

export default function PaymentRedirect() {
  const cart = useSelector((state) => state.checkout.cart)
  const [getCart, { data }] = useLazyGetCartQuery()

  function goToCheckout() {
    window.location.replace(data.cart.checkoutUrl)
  }

  useEffect(() => {
    document.title = "Payment - Kakaako Wine - Checkout"

    getCart(cart.id)

    analytics.track("page_view", {
      cart_id: cart.id,
      page_title: 'Payment Redirect',
      page_location: window.location.href,
    })
  }, [])

  useEffect(() => {
    if (!data) return

    const isCartReadyForCheckout = (cart) => {
      // No checkout URL means not ready
      if (!cart.checkoutUrl) return false

      // Check if buyer identity is set
      if (!cart.buyerIdentity?.email) return false

      // If there are physical products, check delivery options
      const hasDeliveryGroups = cart.deliveryGroups && cart.deliveryGroups.length > 0
      const needsShipping = hasDeliveryGroups

      if (needsShipping) {
        // Check if delivery options are selected where needed
        const missingDeliverySelection = cart.deliveryGroups.some(
          group => !group.selectedDeliveryOption
        )
        if (missingDeliverySelection) return false
      }

      // No line items means not ready
      if (!cart.lines?.edges?.length) return false

      return true
    }

    if (isCartReadyForCheckout(data.cart)) {
      goToCheckout()
    } else {
      getCart(cart.id, false)
    }

    setTimeout(() => {
      // Force page to redirect to checkout if not yet redirected after 10s.
      goToCheckout()
    }, 10000)
  }, [data])

  return (
    <Box>
      <Typography component="h2" variant="h5" gutterBottom>
        Payment
      </Typography>
      <Box
        component={Paper}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        padding={2}
      >
        <CircularProgress />
        <Typography variant="body1" textAlign="center" mt={2}>
          We are redirecting you to the payment page... Please wait.
        </Typography>
      </Box>
      <HawaiiGet />
    </Box>
  )
}
